export const isExternalUrl = (url: string) => {
  try {
    const linkHostname = new URL(url).hostname;

    // On server-side, assume all absolute URLs are external
    if (import.meta.server) {
      return true;
    }

    // On client-side, compare with current hostname
    return linkHostname !== window.location.hostname;
  } catch (error) {
    return false;
  }
};
